import HTTPClient from '@elab/core/utils/HTTPClient';
import apiUtils from '@elab/core/utils/apiUtils';
import cartApi from '@elab/core/store/cart/api';

const getApiService = () => `${apiUtils.getBaseUri()}`;

const categoryProducts = async categoryCode => {
    const uri = `${getApiService()}/categories/${categoryCode}/products?fields=FULL`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to get samples: (${response})`);
    }
    return await response.json();
};

const refuseFreeSamples = async (userId, cartId, status) => {
    const uri = `${cartApi.getCurrentCartApiService(
        userId,
        cartId,
    )}/freesamples/refuse?refuseFreeSamples=${status}`;
    const response = await HTTPClient().putJson(uri);
    if (!response.ok) {
        throw new Error(`Unable to get samples: (${response})`);
    }
};

export default {
    categoryProducts,
    refuseFreeSamples,
};
